var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"app-label",style:({color: _vm.color})},[_c('span',{staticClass:"app-label__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }